const id = 'fiatRamp'

export default id
